export class EncryptionTypeFilters {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "containsAnyOf",
            "baseName": "containsAnyOf",
            "type": "Array<EncryptionType>",
            "format": ""
        },
        {
            "name": "containsNoneOf",
            "baseName": "containsNoneOf",
            "type": "Array<EncryptionType>",
            "format": ""
        },
        {
            "name": "containsAllOf",
            "baseName": "containsAllOf",
            "type": "Array<EncryptionType>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return EncryptionTypeFilters.attributeTypeMap;
    }
    constructor() {
    }
}
